export default function ZehumaPortalAbout() {
    return (
        <div className="px-4 py-12 sm:py-16">
            <div className="mx-auto max-w-3xl">
                <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">Hakkımızda</h1>
                <p className="mt-2 text-lg font-semibold text-violet-700">Dijital Geleceği Şekillendiren Güç</p>

                <div className="prose prose-slate mt-8 max-w-none text-slate-700">
                    <p className="text-base leading-relaxed">
                        Zehuma Bilgi Teknolojileri A.Ş., 25 yıllık köklü geçmişiyle teknoloji ve yaratıcılığı birleştirerek markalara benzersiz dijital deneyimler sunan yeni nesil bir teknoloji üssüdür.
                    </p>
                    <p className="mt-4 text-base leading-relaxed">
                        Girişimlerden Fortune 500 şirketlerine kadar geniş bir yelpazede, sadece bir hizmet sağlayıcı değil, iş hedeflerinize ulaşmanızı sağlayan stratejik çözüm ortağınızız.
                    </p>
                </div>
            </div>
        </div>
    );
}
